const characterCount = text => {
  let copySize = text.length > 220 ? "large" : "small"
  return copySize
}

export default characterCount
